export var primitives = {
  neutral: {
    0: '#FFFFFF',
    50: '#F5F5F5',
    100: '#e7e7e7',
    200: '#d1d1d1',
    300: '#b0b0b0',
    400: '#888888',
    500: '#6d6d6d',
    600: '#595959',
    700: '#4f4f4f',
    800: '#454545',
    900: '#2E2E2E',
    1000: '#000000'
  },
  informative: {
    success: {
      50: '#F5FBEE',
      100: '#F1F7E6',
      200: '#B2DB80',
      300: '#84C533',
      400: '#65B700',
      500: '#5BA500',
      600: '#18AD00',
      700: '#468000',
      800: '#0A6600'
    },
    error: {
      50: '#FFE9EB',
      100: '#FDDCDF',
      200: '#F98A95',
      300: '#F65B6A',
      400: '#F2142A',
      500: '#DD0016',
      600: '#BA0012',
      700: '#99000F',
      800: '#73000B'
    },
    info: {
      50: '#ECF7FE',
      100: '#B3E0FB',
      200: '#8CD0F9',
      300: '#66C1F7',
      400: '#40B1F5',
      500: '#0078D4',
      600: '#006CBE',
      700: '#0060AA',
      800: '#005494'
    },
    warning: {
      50: '#FFF8EB',
      100: '#FFF2DA',
      200: '#FFD583',
      300: '#FFBB38',
      400: '#FFAA06',
      500: '#FF7903',
      600: '#FF4800',
      700: '#D13B00',
      800: '#B13200'
    }
  },
  brand: {
    50: '#FEE6F2',
    100: '#fbb3d8',
    200: '#f980be',
    300: '#f64da4',
    400: '#f2007d',
    500: '#E00069',
    600: '#C20064',
    700: '#A90058',
    800: '#91004b'
  },
  interaction1: {
    50: '#FEE6F2',
    100: '#fbb3d8',
    200: '#f980be',
    300: '#f64da4',
    400: '#f2007d',
    500: '#E00069',
    600: '#C20064',
    700: '#A90058',
    800: '#91004b'
  },
  interaction2: {
    50: '#FEE6F2',
    100: '#fbb3d8',
    200: '#f980be',
    300: '#f64da4',
    400: '#f2007d',
    500: '#E00069',
    600: '#C20064',
    700: '#A90058',
    800: '#91004b'
  }
};